import { render, staticRenderFns } from "./productionBatchInventory.vue?vue&type=template&id=9269875a&scoped=true&"
import script from "./productionBatchInventory.vue?vue&type=script&lang=tsx&"
export * from "./productionBatchInventory.vue?vue&type=script&lang=tsx&"
import style0 from "./productionBatchInventory.vue?vue&type=style&index=0&id=9269875a&lang=scss&scoped=true&"
import style1 from "./productionBatchInventory.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9269875a",
  null
  
)

export default component.exports